import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    title: 'Are you a tax resident in the same country you live in?',
    description:
      'Your country of tax residence is the main country where you pay tax.',
    yes: 'Yes',
    no: 'No',
  },
  de: {
    title: 'Bist du in dem Land, in dem du lebst, steuerlich ansässig?',
    description:
      'Dein Steuerwohnsitz ist das Hauptland, in dem du Steuern zahlst.',
    yes: 'Ja',
    no: 'Nein',
  },
});
